import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DataTable from "examples/Tables/DataTable";

//React Hooks and Others
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { CircularProgress, Icon, Tooltip } from "@mui/material";
import ComponentsPrivatization, {
  removeColumns,
} from "config/component_privatization";
import { COORDINADOR_ALMACEN } from "roles";
import { style_icon } from "helpers/global_vars";
import {
  UNIDADES_EDIT_URL,
  UNIDADES_NEW_URL,
  UNIDADES_URL,
} from "config/bases_url";
import { useDeleteUnidadMutation, useGetUnidadesQuery } from "services";
import { useRedirectForm } from "hooks/useRedirectForm";
import usePagination from "hooks/usePagination";

function DataTableUnidades({ tableHeader }) {
  const navigate = useNavigate();

  const {
    offset,
    setOffset,
    limit,
    busqueda,
    setBusqueda,
    handleNext,
    handlePrevious,
  } = usePagination();

  const {
    data: unidades,
    isLoading: isLoadingG,
    isError: isErrorG,
    error: errorG,
  } = useGetUnidadesQuery(
    {
      filter_params: {
        buscar: busqueda,
        offset: offset,
        limit: limit,
        query: "{id,nombre,nombre_corto,decimal}",
      },
      shape: {
        id: "id",
        nombre: "nombre",
        nombre_corto: "nombre_corto",
        decimal: "decimal",
      },
    },
    {
      refetchOnReconnect: true,
    }
  );

  //constantes para manejar la paginacion
  const dataUnidades = unidades?.results ? unidades.results : unidades;
  const countTotal = unidades?.count;
  const previous = unidades?.previous;
  const next = unidades?.next;

  const [
    deleteUnidad,
    {
      isSuccess: isSuccessD,
      isLoading: isLoadingD,
      isError: isErrorD,
      error: errorD,
    },
  ] = useDeleteUnidadMutation();

  const dataTable = {
    columns: [
      {
        Header: "Nombre",
        accessor: "nombre",
      },
      {
        Header: "Nombre corto",
        accessor: "nombre_corto",
      },
      {
        Header: "Es decimal",
        accessor: "decimal",
        Cell: ({ value }) => (value ? "Si" : "No"),
      },
      {
        Header: "Acciones",
        accessor: "actions",
        width: "10%",
        Cell: ({ row }) => {
          const { original } = row;

          return (
            <ComponentsPrivatization permitted={COORDINADOR_ALMACEN}>
              <MDBox display="flex">
                <MDBox px={0.2}>
                  <Tooltip placement="top" title="Editar">
                    <Icon
                      style={style_icon}
                      onClick={() => handleClickEdit(original)}
                      fontSize="small"
                    >
                      edit
                    </Icon>
                  </Tooltip>
                </MDBox>
                {original.borrable && (
                  <MDBox px={0.2}>
                    <Tooltip placement="top" title="Eliminar">
                      <Icon
                        style={style_icon}
                        onClick={(event) => handleClickErase(original)}
                        fontSize="small"
                      >
                        remove_circle
                      </Icon>
                    </Tooltip>
                  </MDBox>
                )}
              </MDBox>
            </ComponentsPrivatization>
          );
        },
      },
    ],
    rows: dataUnidades ?? [],
  };

  useRedirectForm(
    isLoadingG,
    null,
    isErrorG,
    errorG,
    "Hubo problemas para cargar la información",
    UNIDADES_URL
  );

  useRedirectForm(
    isLoadingD,
    isSuccessD,
    isErrorD,
    errorD,
    "Unidad de medida eliminada",
    UNIDADES_URL
  );

  const handleClickErase = (el) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: `¡Si elimina la unidad de medida: "${el.nombre}", esta acción no se podrá revertir!`,
      icon: "warning",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteUnidad(el.id);
      }
    });
  };

  const handleClickEdit = ({ id }) => {
    navigate(UNIDADES_EDIT_URL(id));
  };

  return (
    <MDBox pt={6} pb={3}>
      <Card>
        <MDBox
          display="flex"
          justifyContent={"space-between"}
          alignItems={"center"}
          m={2}
          p={3}
        >
          <MDTypography variant="h5" fontWeight="medium">
            {tableHeader}
          </MDTypography>
          <ComponentsPrivatization permitted={COORDINADOR_ALMACEN}>
            <Link to={UNIDADES_NEW_URL}>
              <MDButton variant="gradient" color="info" size="medium">
                nuevo
              </MDButton>
            </Link>
          </ComponentsPrivatization>
        </MDBox>
        <MDBox display="flex" justifyContent={"center"} alignItems={"center"}>
          {isLoadingG ? (
            <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
          ) : (
            <DataTable
              table={removeColumns(
                dataTable,
                () =>
                  !JSON.parse(sessionStorage.getItem("user")).groups.some(
                    (role) => role.name === COORDINADOR_ALMACEN
                  ),
                ["actions"]
              )}
              canSearch
              paginationApi
              countTotal={countTotal}
              next={next}
              previous={previous}
              handleNext={handleNext}
              handlePrevious={handlePrevious}
              offset={offset}
              setOffset={setOffset}
              setBusqueda={setBusqueda}
            />
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}

DataTableUnidades.propTypes = {
  tableHeader: PropTypes.string.isRequired,
};

export default DataTableUnidades;
